import ModalComponent from '@components/modal/Modal.component';
import NewTableComponent from '@components/table/NewTable.component';
import { Stack, Tab, Tabs } from '@mui/material';
import { GridValueGetterParams } from '@mui/x-data-grid-pro';
import { useObservable } from '@ngneat/react-rxjs';
import { ProposalOffer } from '@store/audits/audit-offer-followUp/audit-offer-followUp.model';
import { auditsFollowUpService } from '@store/audits/audit-offer-followUp/audit-offer-followUp.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import { ServiceKindTypeEnum } from '@store/settings/serviceKinds/serviceKinds.model';
import COLUMN_TYPES from '@utils/table/columnTypes.table';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DetailsModalProps {
  handleClose?: () => void;
  partnerId?: string;
}


const DetailsModal = (props: DetailsModalProps) => {
  const { handleClose, partnerId } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState<ServiceKindTypeEnum>();
  const [offerItem, setOfferItem] = useState<{
    label: string;
    value: ServiceKindTypeEnum;
  }[]
  >();
  const [{ allAuditsOfferFromProposal }] = useObservable(auditOfferFollowUpQuery.allAuditsOfferFromProposal$);
  const [{ auditsProposalDetails }] = useObservable(auditOfferFollowUpQuery.auditProposalDetails$);

  const OffersPropFiltered = allAuditsOfferFromProposal?.filter((it) => it.family.includes(tabs || '')).sort((a, b) => a.container.localeCompare(b.container));

  useEffect(() => {
    if (allAuditsOfferFromProposal && allAuditsOfferFromProposal?.length > 0) {
      const allAvaillaibleFamilly = allAuditsOfferFromProposal.map((it) => it.family);
      const tabsFamilly = _.intersection(Object.keys(ServiceKindTypeEnum), allAvaillaibleFamilly);
      const allTabs = ServiceKindTypeEnum.selectItems().filter((it) => tabsFamilly.includes(it.value));
      setTabs(allTabs[0]?.value);
      setOfferItem(allTabs);
    }
  }, [allAuditsOfferFromProposal]);


  useEffect(() => {
    if (partnerId) {
      setLoading(true);
      auditsFollowUpService.getAuditsOfferFromProposal(partnerId).subscribe(() => {
        setLoading(false);
      });
    }
  }, [partnerId]);

  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.auditOfferFollowUp.modal.detailsOffer.title', { offer: auditsProposalDetails?.name || '' })}
      handleClose={handleClose}
      contentFullWidth
      maxWidth='lg'
      content={(
        <Stack width="100%" height='70dvh' bgcolor='#FFFFFF' spacing={3}>
          <Tabs
            value={tabs}
            onChange={(_, value) => setTabs(value)}
            aria-label={'primary'}
            variant={'standard'}
            sx={{ color: '#192133', paddingLeft: '24.5px' }}
          >
            {offerItem?.map((it) => (
              <Tab
                key={`Tab ${it.value} - ${it.label}`}
                label={it.label}
                value={it.value}
              />
            ))}
          </Tabs>
          <NewTableComponent
            columns={[
              COLUMN_TYPES.TEXT({
                field: 'container',
                width: 200,
                color: 'secondary',
                label: 'Contenants',
                editable: false,
                valueGetter: (params: GridValueGetterParams<any, ProposalOffer>) => params.row.container,
                valueFormatter: (params) => params.value,
              }),
              COLUMN_TYPES.TEXT({
                field: 'waste',
                width: 200,
                color: 'secondary',
                label: 'Type de déchet',
                editable: false,
                valueGetter: (params: GridValueGetterParams<any, ProposalOffer>) => params.row.waste,
                valueFormatter: (params) => params.value,
              }),
              COLUMN_TYPES.TEXT({
                field: 'prestations',
                width: 200,
                color: 'secondary',
                label: 'Prestation',
                editable: false,
                valueGetter: (params: GridValueGetterParams<any, ProposalOffer>) => params.row.prestations,
                valueFormatter: (params) => params.value,
              }),
            ]}
            disablePagination
            disableRowSelectionOnClick={true}
            disableRowSelection={true}
            loading={loading}
            data={OffersPropFiltered || []}
          />
        </Stack >
      )}
    />
  );
};

export default DetailsModal;
